var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9701 5.50601C12.8915 5.25873 12.6883 5.08014 12.4393 5.03892L9.09053 4.53062L7.5898 1.35031C7.36699 0.883228 6.63301 0.883228 6.4102 1.35031L4.90947 4.53062L1.5607 5.04579C1.31167 5.08701 1.10851 5.2656 1.02987 5.51288C0.957787 5.76016 1.01677 6.03492 1.20026 6.22038L3.62501 8.69319L3.05487 12.1963C3.01555 12.4574 3.11385 12.7115 3.317 12.8695C3.43496 12.9519 3.56603 13 3.70365 13C3.80851 13 3.91336 12.9725 4.00511 12.9176L7 11.2622L10.0014 12.9176C10.2243 13.0343 10.493 13.0137 10.6896 12.8626C10.8927 12.7046 10.9976 12.4505 10.9517 12.1895L10.375 8.69319L12.7997 6.21351C12.9832 6.02805 13.0422 5.76016 12.9701 5.50601Z",
    fill: "#FFE395"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9701 5.50601C12.8915 5.25873 12.6883 5.08014 12.4393 5.03892L9.09053 4.53062L7.5898 1.35031C7.36699 0.883228 6.63301 0.883228 6.4102 1.35031L4.90947 4.53062L1.5607 5.04579C1.31167 5.08701 1.10851 5.2656 1.02987 5.51288C0.957787 5.76016 1.01677 6.03492 1.20026 6.22038L3.62501 8.69319L3.05487 12.1963C3.01555 12.4574 3.11385 12.7115 3.317 12.8695C3.43496 12.9519 3.56603 13 3.70365 13C3.80851 13 3.91336 12.9725 4.00511 12.9176L7 11.2622L10.0014 12.9176C10.2243 13.0343 10.493 13.0137 10.6896 12.8626C10.8927 12.7046 10.9976 12.4505 10.9517 12.1895L10.375 8.69319L12.7997 6.21351C12.9832 6.02805 13.0422 5.76016 12.9701 5.50601",
    stroke: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.023c5d3dbc4f1421cac7110ae3f92cc2.svg";
export { ForwardRef as ReactComponent };